import {
    IMLPackageVersion,
    MLPackageStatus,
} from '@models';

export interface IMLPackage {
    id: string;
    name: string;
    description: string;
    published: Date;
    inputType: string;
    latestVersionInputDescription: string;
    latestVersionOutputDescription: string;
    modelVersions: IMLPackageVersion[];
    status: MLPackageStatus;
}

export interface ISignedUrlResponse {
    value: string;
}

export enum MLInputType {
    json = 'JSON',
    file = 'FILE',
    png = 'PNG',
    tiff = 'TIFF',
    pdf = 'PDF',
    jpeg = 'JPEG',
    jpg = 'JPG',
    nums = 'NUM_ARR',
    strings = 'STRING_ARR',
    files = 'FILE_LIST',
}
